<app-drones [intervention]="intervention" [isInterventionRequired]="true"></app-drones>
